import 'icheck';
import noUiSlider from 'nouislider';
import wNumb from "wnumb";

(function ($) {
    "use strict";

    $('.filter input[type="checkbox"], .filter input[type="radio"]').iCheck({
        checkboxClass: 'icheckbox_square-aero',
        radioClass: 'iradio_square-aero',
    });

    // Change display without reloading the whole page
    $('#btn-grid, #btn-list').change(function (e) {
        $('#display').removeClass('list grid').addClass($(this).val());
        $('.search .property .images').trigger('refresh.owl.carousel');
    });

    $(window).on('load', function () {
        $('.search .property .images').owlCarousel({
            nav: true,
            dots: false,
            items: 1,
            // animateOut: 'fadeOut',
            lazyLoad: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false
        });

        if ($('#collapse-map > .map[data-multiple]').length) {
            let $map = $('#collapse-map > .map');

            //set up markers
            let markers = [];
            $('.property').each(function (i, el) {
                let $el = $(el);
                markers.push({
                    "latitude": $el.data('lat'), "longitude": $el.data('lng'), "icon": "/img/map-marker.png", 'href': $el.data('href')
                })
            });

            //set up map options
            $map.mapmarker({
                zoom: 16,
                markers: {
                    'markers': markers
                }
            });
        }

        $('.submit-form').change(function () {
           $($(this).prop('form')).submit();
        });

        /*
        ** Price slider for filtering
         */
        let $priceSlider = $('#price-slider');
        if ($priceSlider.length) {
            let rangeSlider = document.getElementById('price-slider');
            let format = wNumb({
                decimals: 0,
                suffix: ' ' + $priceSlider.data('currency')
            });
            noUiSlider.create(rangeSlider, {
                start: [$priceSlider.data('start-min'), $priceSlider.data('start-max')],
                step: 10,
                tooltips: true,
                range: {
                    'min': [$priceSlider.data('bound-min')],
                    'max': [$priceSlider.data('bound-max')]
                },
                format: wNumb({
                    decimals: 0,
                    suffix: ' ' + $priceSlider.data('currency')
                })
            });
            rangeSlider.noUiSlider.on('update', function (values, handle) {
                let $item = $('#price-details .min');
                let $input = $('#min-price');
                if (handle > 0) {
                    $item = $('#price-details .max');
                    $input = $('#max-price');
                }
                $item.text(values[handle]);
                $input.val(format.from(values[handle]));
            });
        }
    });
})(window.$);
